import { Component, OnInit, OnChanges, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-tickets-ticket-templates-info-card',
  templateUrl: './tickets-ticket-templates-info-card.component.html',
  styleUrls: ['./tickets-ticket-templates-info-card.component.scss']
})
export class TicketsTicketTemplatesInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() ticket;
  editorConfig: AngularEditorConfig;
  ticketHtmlPlaceholder: string;
  ticketTextPlaceholder: string;
  updateTicketTemplatesSubscription: Subscription;
  basicDataForm = new FormGroup({
    ticketHtmlFlag: new FormControl(false),
    htmlContent: new FormControl(''),
    ticketTextFlag: new FormControl(false),
    textContent: new FormControl('')
  });

  constructor(private snackbarService: SnackBarService,
    private ticketsService: TicketsService) {
      this.ticketHtmlPlaceholder = 'Example:\n\n<meta charset="UTF-8">\n<link href="https://fonts.googleapis.com/css?family=Open+Sans&amp;display=swap" rel="stylesheet">\n<style>\nbody {\nwidth: 100%;\nmargin: 0;\nfont-family: "Open Sans", sans-serif;\n}\nheader {\ndisplay: flex;\nflex-direction: column;\njustify-content: center;\nalign-items: center;\n}\nheader > img {\nwidth: 60%;\n}\nmain {\ndisplay: flex;\nflex-direction: column;\njustify-content: center;\ntext-align: center;\nalign-items: center;\n}\nmain>h2 {\nfont-size: 50px;\nmargin: 0;\n}\nmain>h3 {\nfont-size: 200px;\nmargin: 0;\n}\nfooter {\ndisplay: flex;\nflex-direction: row;\njustify-content: space-around;\nalign-items: center;\n}\nfooter > h5 {\nfont-size: 25px;\nfont-weight: 300;\nmargin-top: 25px;\n}\n</style>\n<div>\n<header>\n<img src="${companyImageXlUrl}" alt="InfosFrance">\n</header>\n<main>\n<h3>${myTurn}</h3>\n<h2>${deskTurn}</h2>\n</main>\n<footer>\n<h5>${date}</h5>\n<h5>${hours}</h5>\n<h5>${store}</h5>\n</footer>\n</div>\n';
      this.ticketTextPlaceholder = 'Example:\n\n@a{${store}\nFecha: ${date} ${hours}\n!0E${deskTurn}\n!fE${myTurn}\n!0E?mETurn\nVB??';
    }

  ngOnInit() {
    this.editorConfig = {
      spellcheck: false,
      sanitize: false,
      height: '25rem',
      minHeight: '5rem',
      placeholder: this.ticketHtmlPlaceholder,
      translate: 'no',
      uploadUrl: 'v1/images',
      customClasses: []
    };
  }

  ngOnChanges() {
    if (this.ticket) {
      this.resetForm();
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation === true) {
      this.updateTicketTemplatesSubscription = this.ticketsService.updateTicketTemplates(this.ticket.InternalId, this.ticket.Active, this.ticket.CenterInternalId, this.basicDataForm.get('ticketHtmlFlag').value, this.basicDataForm.get('htmlContent').value, this.basicDataForm.get('ticketTextFlag').value, this.basicDataForm.get('textContent').value).subscribe(
        (res) => {
          this.snackbarService.open('tickets-page.snackbar messages.update ticket success', 'success');
          this.ticketsService.refreshTicket();
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
        this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (this.basicDataForm.get('ticketHtmlFlag').value && !this.basicDataForm.get('htmlContent').value) {
      return 'tickets-page.snackbar messages.empty html ticket error';
    } if (this.basicDataForm.get('ticketTextFlag').value && !this.basicDataForm.get('textContent').value) {
      return 'tickets-page.snackbar messages.empty text ticket error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      ticketHtmlFlag: this.ticket.TicketHtmlFlag,
      htmlContent: this.ticket.TicketHtml,
      ticketTextFlag: this.ticket.TicketTextFlag,
      textContent: this.ticket.TicketText
    });
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.updateTicketTemplatesSubscription) { this.updateTicketTemplatesSubscription.unsubscribe(); }
  }
}
